"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNotificationListState = exports.NotificationListContextProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const lodash_es_1 = require("lodash-es");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const getNotifications_1 = require("../api/getNotifications");
const useNotificationListFilters_1 = require("./useNotificationListFilters");
const NotificationListContext = (0, react_1.createContext)({});
const NotificationListContextProvider = ({ children }) => {
    const location = (0, react_router_dom_1.useLocation)();
    const filters = (0, useNotificationListFilters_1.useNotificationListFilters)();
    const { typeFilter, statusFilter, startDateFilter, endDateFilter, sortBy } = filters;
    const [selectedNotification, setSelectedNotification] = (0, react_1.useState)(null);
    const urlNotificationID = location.pathname.split('/')[2];
    const notificationsQuery = (0, getNotifications_1.useNotifications)((0, lodash_es_1.pickBy)({ type: typeFilter, status: statusFilter, startDate: startDateFilter, endDate: endDateFilter, orderBy: sortBy }, lodash_es_1.identity), urlNotificationID);
    const state = (0, react_1.useMemo)(() => ({
        ...notificationsQuery,
        ...filters,
        selectedNotification,
        setSelectedNotification,
    }), [notificationsQuery, filters]);
    (0, react_1.useEffect)(() => {
        const targetNotification = notificationsQuery.notificationResults.data?.results?.find(({ id }) => id === location.pathname.split('/')[2]);
        if (targetNotification && selectedNotification?.id !== targetNotification.id) {
            setSelectedNotification(targetNotification);
        }
    }, [location.pathname]);
    (0, react_1.useEffect)(() => {
        if (!urlNotificationID && selectedNotification) {
            setSelectedNotification(null);
        }
        if (urlNotificationID && notificationsQuery.notificationResults?.data?.results && !selectedNotification) {
            const notification = notificationsQuery.notificationResults.data.results.find(({ id }) => id === urlNotificationID);
            if (notification) {
                setSelectedNotification(notification);
            }
            if (notificationsQuery.page !== notificationsQuery.notificationResults?.data?.page) {
                notificationsQuery.onPageChange({}, (notificationsQuery.notificationResults?.data?.page || 1) - 1);
            }
        }
    }, [notificationsQuery.notificationResults]);
    return (0, jsx_runtime_1.jsx)(NotificationListContext.Provider, { value: state, children: children });
};
exports.NotificationListContextProvider = NotificationListContextProvider;
const useNotificationListState = () => {
    const context = (0, react_1.useContext)(NotificationListContext);
    if (!context) {
        throw new Error('Must use useNotificationListState in NotificationListContextProvider');
    }
    return context;
};
exports.useNotificationListState = useNotificationListState;
//# sourceMappingURL=useNotificationListState.js.map